// libraries
import React, { useState, useEffect, useContext } from 'react';
import { Helmet } from 'react-helmet-async';
import { ToastContainer, toast } from 'react-toastify';

import { Link, useParams, Redirect } from 'react-router-dom';

import axios from 'axios';

function Resource() {
  const { slug } = useParams();
  const [html, setHtml] = useState('<html> </html>');
  const [isLoading, setIsLoading] = useState(true);
  const [webinar, setwebinar] = useState(null);

  const resourceDetails = {
    STTP1: {
      slug:
        '2PACX-1vSq0Rnin-QAw4UMKFvWYoa3dmDGeH0UVelqZP4PGW3I1VpYFBX4U2SuoQeqtkcQJciKTvxYsGH8m2kK',
      back: '/events/id/STTP2021AI'
    },
    STTP2: {
      slug:
        '2PACX-1vSFbevZ3GACt91gAt__i54g3COP5FpEYCaGebeMIc3GpycbQuXp_b2YE1dedq8vwSkMQyHYAa6kwN-L',
      back: '/events/id/STTP2021AI2'
    },
    FOPOS: {
      slug:
        '2PACX-1vTHr8iB2RrarpuQ3JHoBa99U7CbsjGDvqI0a_my-VuREqetLLSy3_S0mxVFirXJNS-d_8Ob2A22onma',
      back: '/events/id/FOPOS2021'
    },

  };
  useEffect(() => {
    const getResult = async () => {
      setwebinar(resourceDetails[slug]);
      setIsLoading(false);
      const r = await axios.get(
        'https://docs.google.com/document/d/e/' +
          resourceDetails[slug].slug +
          '/pub?embedded=true'
      );
      const re = r.data
        .replace(/<a\s/gi, '<a target="_blank" ')
        // .replace('padding:43.2pt 14.4pt 14.4pt 14.4pt', '')
        .replace(/(<script[\s\S]+?<\/script>)/gi, '')
        .replace(/(<body[\s\S]+?>)/gi, '<body>')
        // .replace('https://www.google.com/url?q=h', 'h')
        // .replace(/(&amp;amp;sa=D[\s\S]+?>)/gi, '&quot;>')

        .replace(/(<div id="header">[\s\S]+?<\/div>)/, '')
        .replace(/(<div id="footer">[\s\S]+?<\/div>)/, '');
      setHtml(re);
    };
    var iframe = document.getElementById('googledoc');
    iframe.addEventListener('load', function (e) {
      // document.title = iframe.contentWindow.document.title;
      setTimeout(function () {
        var height = iframe.contentWindow.document.body.offsetHeight + 50;

        document
          .getElementsByClassName('iframe-wrapper')[0]
          .setAttribute('style', 'height: ' + height + 'px;');
      }, 1000);
    });

    getResult();
  }, []);

  return (
    <>
      <Helmet>
        <title>
          {`Resources - K. J. Somaiya Institute of Engineering and Information Technology`}
        </title>
        {/* <meta
            name="description"
            content={`NLWS - K. J. Somaiya Institute of Engineering and Information Technology`}
          /> */}
      </Helmet>
      <div className="resources">
        <ToastContainer />
        <div className="top-bar">
          <Link
            to={resourceDetails[slug].back}
            className="btn-primary lr"
            className="btn-back"
          >
            <i style={{ color: '#b7202e' }} className="fa fa-arrow-left" />
            {'Back'}
          </Link>
        </div>
      </div>
      <div class="iframe-wrapper">
        <iframe id="googledoc" srcDoc={html}></iframe>
      </div>
    </>
  );
}

export default Resource;
